//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CatImage } from 'counselor-mobile-ui'
import { STATUS_CONF } from '@/public/config/statusConf'
import { genderName } from '@/public/config/genderConf'

export default {
  components: { CatImage },

  props: {
    info: {
      type: Object,
      default: () => ({}),
    },

    auditor: {
      type: String,
      default: '',
    },

    isShared: {
      type: Boolean,
      default: false,
    },

    status: {
      type: String,
      default: '',
    },
  },

  computed: {
    statusInfo () {
      return STATUS_CONF[this.status] || {}
    },

    genderName () {
      return genderName[this.info.gender]
    },
  },

  methods: {
    getShortName (name) {
      return ''
    },
  },
}
